
import React from 'react';
import Rajyostava2024 from 'views/Rajyostava2024';
const RentalPage = () => {
  return <Rajyostava2024 />;
};

export default RentalPage;